export const reducerToggleSidebar = (state) => ({
  ...state,
  isSidebarOpen: !state.isSidebarOpen,
})
